import { render } from "./SC.vue?vue&type=template&id=8936a3e4"
import script from "./SC.vue?vue&type=script&lang=js"
export * from "./SC.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\sisco\\Documents\\Compras\\SC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__